var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterestedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83306 1.66797L1.41094 10.5745C1.12026 10.9233 0.974925 11.0977 0.972704 11.245C0.970773 11.3731 1.02783 11.4949 1.12744 11.5754C1.24201 11.668 1.46904 11.668 1.92308 11.668H7.99972L7.16639 18.3346L14.5885 9.42809C14.8792 9.07928 15.0245 8.90488 15.0267 8.75758C15.0287 8.62954 14.9716 8.50772 14.872 8.42722C14.7574 8.33464 14.5304 8.33464 14.0764 8.33464H7.99972L8.83306 1.66797Z",
    stroke: "#00AA38",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestedIcon);
export default __webpack_public_path__ + "static/media/interestedIcon.c33df4703befce0a85c91ebd383da95c.svg";
export { ForwardRef as ReactComponent };